import React from 'react';
import { Tab, Tabs } from '@mui/material';
import { libraryTabSx } from '../../designTokens';

/** Compact Edit / Preview tabs — matches Chat / Creator underline style. */
export const editPreviewTabSx = {
  ...libraryTabSx,
  minHeight: 36,
  minWidth: 0,
  px: 1.25,
  py: 0.5,
  fontSize: '0.8125rem',
};

/**
 * Standard Edit / Preview tab selector used across builder, prompt modal, and knowledge surfaces.
 */
export default function EditPreviewToggle({
  mode = 'preview',
  onToggle,
  onModeChange,
  onBeforeToggle,
  onBeforeModeChange,
  disabled = false,
  sx,
  ...rest
}) {
  const handleChange = async (_, nextMode) => {
    if (!nextMode || nextMode === mode) return;
    const beforeChange = onBeforeModeChange || onBeforeToggle;
    if (beforeChange) {
      await beforeChange();
    }
    if (onModeChange) {
      onModeChange(nextMode);
    } else if (onToggle) {
      onToggle();
    }
  };

  return (
    <Tabs
      value={mode}
      onChange={handleChange}
      sx={{
        minHeight: 36,
        ...sx,
        '& .MuiTabs-indicator': {
          height: 2,
          backgroundColor: 'primary.main',
        },
      }}
      {...rest}
    >
      <Tab value="edit" label="Edit" disabled={disabled} sx={editPreviewTabSx} />
      <Tab value="preview" label="Preview" disabled={disabled} sx={editPreviewTabSx} />
    </Tabs>
  );
}
